import { createTheme } from "@mui/material/styles";

import { components } from "./components";
import { colors, palette } from "./palette";
import { shadows } from "./shadows";
import typography from "./typography";

const muiTheme = createTheme();

const breakpoints = {
  values: {
    xs: 0,
    sm: 640,
    md: 905,
    lg: 1280,
    xl: 1440,
  },
};

const theme = createTheme({
  breakpoints,
  components,
  palette,
  typography,
  shadows: shadows(muiTheme),
});

export { colors, theme };
